import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row } from "reactstrap";
import {
  decreaseQuantity,
  increaseQuantity,
} from "../store/actions/cartAction";
import { FaMinus, FaPlus } from "react-icons/fa";
import { checkFinalPrice } from "./checkFinalPrice";
import { toast } from "react-toastify";

const ItemCounter = ({
  selectedItem,
  setSelectedItemsSize,
  cartItem,
  type,
}) => {
  const { darkMode, color } = useSelector((state) => state.global);
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);

  const [value, setValue] = useState(1);

  const itemPrice = parseFloat(cartItem?.price) || 0;

  const simulatedFinal = checkFinalPrice({
    cartItems: cartItems,
    restaurant: restaurantsDetail,
    itemPrice: itemPrice,
  });

  const isDisabled = simulatedFinal > 10000;

  const increment = () => {
    const newQuantity = value + 1;
    setValue(newQuantity);
    setSelectedItemsSize(newQuantity);
  };

  const handleQuantityIncrease = () => {
    if (type === "cart") {
      if (isDisabled) {
        return;
      }

      const simulatedValue = checkFinalPrice({
        cartItems: cartItems,
        restaurant: restaurantsDetail,
        itemPrice: itemPrice * 2,
      });

      if (simulatedValue > 10000) {
        toast.warning("Total amount limit per order is 10,000.");
      }

      dispatch(increaseQuantity(cartItem));
    } else {
      increment();
    }
  };

  const decrement = () => {
    if (value > 1) {
      const newQuantity = value - 1;
      setValue(newQuantity);
      setSelectedItemsSize(newQuantity);
    }
  };

  useEffect(() => {
    if (selectedItem?.quantity === 0) {
      setSelectedItemsSize(1);
      setValue(1);
    }
  }, [selectedItem, setSelectedItemsSize]);

  return (
    <Row className="my-3 mx-1">
      <div
        onClick={() => {
          const quantity =
            type === "cart" ? cartItem.quantity : selectedItem?.quantity || 1;
          if (quantity > 1) {
            type === "cart"
              ? dispatch(decreaseQuantity(cartItem))
              : decrement();
          }
        }}
        style={{
          pointerEvents:
            (type === "cart"
              ? cartItem.quantity
              : selectedItem?.quantity || 1) <= 1
              ? "none"
              : "auto",
        }}
        className={
          darkMode
            ? "top_cards-dark__operators d-flex justify-content-center align-items-center"
            : "top_cards__operators d-flex justify-content-center align-items-center"
        }
      >
        {" "}
        <FaMinus />{" "}
      </div>
      <div
        className={darkMode ? "top_cards-dark__number" : "top_cards__number"}
      >
        {type === "cart" ? cartItem.quantity : selectedItem?.quantity || 1}
      </div>
      <div
        onClick={handleQuantityIncrease}
        style={{
          border: `2px solid ${isDisabled ? "rgb(170, 170, 172)" : color}`,
          color: color,
          pointerEvents: isDisabled ? "none" : "auto",
        }}
        className={
          darkMode
            ? "top_cards-dark__operators-active d-flex justify-content-center align-items-center"
            : "top_cards__operators-active d-flex justify-content-center align-items-center"
        }
      >
        <FaPlus
          style={{
            color: isDisabled ? "rgb(170, 170, 172)" : color,
          }}
        />
      </div>
    </Row>
  );
};

export default ItemCounter;
